export class Search {
   adultos: number;
   criancas: number;
   dataInicial: Date;
   dataFinal: Date;
   noites: number;

   adultosOptions  = [1, 2, 3, 4, 5, 6];
   criancasOptions = [0, 1, 2, 3, 4, 5, 6];

   static default() {
      const search = new Search();
      search.adultos = 1;
      search.criancas = 0;
      search.dataInicial = new Date();
      search.dataFinal = new Date();
      search.dataFinal.setDate(search.dataFinal.getDate() + 1);
      search.noites = 1;
      return search;
   }
}
